const credentials = {
  apiKey: 'AIzaSyBX_PU0kAUjTcSfXMyd4tyYy9N0qDER29U',
  authDomain: 'qikgas-859ec.firebaseapp.com',
  databaseURL: 'https://qikgas-859ec.firebaseio.com',
  projectId: 'qikgas-859ec',
  storageBucket: 'qikgas-859ec.appspot.com',
  messagingSenderId: '250456784574',
  appId: '1:250456784574:web:416ebf2f1495858a50e8ef'
}
export default credentials
